import React, { ReactNode } from "react"

import { useBusinessTheme } from "Shared/hooks/useBusinessTheme"

interface IBusinessThemeProviderProps {
  children: ReactNode
}

export const BusinessThemeProvider = ({ children }: IBusinessThemeProviderProps) => {
  useBusinessTheme()
  return <>{children}</>
}

export default BusinessThemeProvider
